export const isTokenValid = (token: string): boolean => {
  return token !== ''
}
